<template>
  <div class="container">
    <div class="profile-page__wrap profile-block">
      <h1 class="profile-block__title title-h2">ЛИЧНЫЙ КАБИНЕТ</h1>
      <div class="profile-block__tabs">

        <profile-tabs></profile-tabs>

        <div class="profile-block__tab tab-box active">
          <router-view></router-view>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
    import StorePersonal from "@/store/modules/Personal"
    import ProfileTabs from "@/components/Personal/ProfileTabs"
    import {mapGetters} from "vuex";

    export default {
        components: {
          ProfileTabs,
        },
        created() {
            this.$store.registerModule('StorePersonal', StorePersonal);
        },
        computed: {
          //viewProfile: () =>
        },
        methods: {
          ...mapGetters('StorePersonal', ['currentStep'])
        },
        data() {
            return {

            }
        }
    }
</script>